import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import InformationCard from '../../../../../components/InformationCard/InformationCard';
import { getBranding } from '../../../../../store/branding/branding.selectors';

export interface IConciergeInfoProps {
  children?: React.ReactNode;
}

const ConciergeInfo = ({ children }: IConciergeInfoProps) => {
  const customStyling = useSelector(getBranding);
  return (
    <InformationCard borderColor={customStyling.backgroundColor} px={2} pt={1} pb={2}>
      <Box width={1} display="flex" flexDirection="column" justifyContent="space-between">
        {children}
        <Box textAlign="right">
          <Typography className="Body-Regular-Left-Static-Bold">— Alyce Gift Concierge</Typography>
        </Box>
      </Box>
    </InformationCard>
  );
};

export default memo(ConciergeInfo);
